import { render, staticRenderFns } from "./MenuBtnEdit.vue?vue&type=template&id=e445b4b4&scoped=true&"
import script from "./MenuBtnEdit.vue?vue&type=script&lang=js&"
export * from "./MenuBtnEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e445b4b4",
  null
  
)

export default component.exports